<template>
    <div>
        <div v-if="initilizingCart">
            <blurryLoader />
        </div>
        <div class="error_popup popup-desktop" v-if="submitted" style="display:block;">
            <div class="error_box error-pop-desk">
                <img src="@/assets/images/submitted.svg" loading="lazy" alt="" class="image-496">
                <div class="text-block-1101">Processing payment.</div>
                <div class="text-block-1102">Please wait...</div>
            </div>
        </div>
        <section class="section_semaco-top">
            <div class="semaco-top-wrap">
                <div class="semaco_topdiv">
                    <a href="#" class="w-inline-block"><img sizes="(max-width: 479px) 67.2265625px, 84.03125px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-500.png 800w, @/assets/images/NewSelf_Logo-p-500.png 1000w" alt="" src="@/assets/images/NewSelf_Logo-p-500.png" loading="lazy" class="image-31" :class="{'image-31-desk' : !isMobile}"></a>
                    <!--<a href="#" class="link-block-20 w-inline-block" @click.prevent="showChatWindow()">
                        <div class="text-block-351">Need Help</div><img loading="lazy" src="@/assets/images/icon_faq.svg" alt="" class="image-246">
                    </a>-->
                </div>
            </div>
        </section>
        <div class="section_semaglutidecheckout">
            
            <div class="semaco_wrap" v-if="!isMobile">
                <div class="semaco_div">
                    <div class="semaco_payinfo">
                        <div class="step-4">
                            <div class="div-block-1291">
                                <h1 class="heading-8 _1 b checkout">Everything included. One low monthly price.</h1>
                                <div class="text-block-250 checkout">No Membership Fees. No Upcharging for Higher Dosage.</div>
                            </div>
                            <div class="w-form">
                                <form class="step-2-left-payment-form new-checkout new-mobile checkout-desk" @submit.prevent="getStripeToken()">
                                    <a href="#" class="link-block-13 w-inline-block"></a>
                                    <div class="div-block-1290" v-if="isGooglePaySupported">
                                        <div class="text-block-349">EXPRESS CHECKOUT</div>
                                        <!--<div id="applepaybutton" style="width: 70%;"></div>-->
                                        <div id="googlepaybutton" style="width: 70%;height:48px; margin-top: 10px;"></div>
                                    </div>
                                    <div class="text-block-350" v-if="isGooglePaySupported">OR CONTINUE BELOW TO PAY WITH CREDIT CARD</div>
                                    <div class="div-block-1292">
                                        <div class="div-block-853 new">
                                            <div class="text-block-80"><strong>Credit Card</strong></div>
                                            <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103790_visa.png" class="image-471">
                                            <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103780_mastercard.png" class="image-471">
                                            <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103794_AmEx.png" class="image-471">
                                            <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd3610377e_discover.png" class="image-471">
                                        </div>
                                        <div>
                                            <label for="email" class="field-label-4 new">Card Number</label>
                                            <div id="card-element" class="ns-card-element" ref="myElement"></div>
                                        </div>
                                        <label for="email" class="field-label-4">Shipping Address</label>
                                        <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                                        <label for="email" class="field-label-4">
                                            <input type="checkbox" @change="differentShipping = !differentShipping">
                                            Different Billing Address?
                                        </label>
                                        <div v-if="differentShipping">
                                            <label for="email" class="field-label-4">Billing Address</label>
                                            <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressDataBilling" />
                                        </div>
                                        
                                        <button class="submit-button-3 new w-button" :disabled="submitted">
                                            <span v-if="submitted"><img src="@/assets/images/submitted.svg"></span>
                                            <span v-else>Buy Now and Save</span>
                                        </button>
                                        <div class="w-form-fail" style="display:block" v-if="paymentError">
                                            <div>{{errorMessage}}</div>
                                        </div>
                                    </div>
                                    <div class="div-block-1154 div-block-1154-centered">
                                        <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                                        <div class="text-block-252">
                                            By clicking "Buy Now and Save" or checking out with Apple or Google Pay you agree to enroll in a 3-month program billed <span v-if="paymentInfo.payment_terms==1">monthly</span><span v-else>quarterly</span>, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the <a :href="`${appMainWeb}/returns`" target="_blank">Refund Policy</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms and Conditions</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms of Use</a>, <a :href="`${appMainWeb}/privacy`" target="_blank">Privacy Policy</a>, <a :href="`${appMainWeb}/hipaa`" target="_blank">HIPAA Notice</a>, and <a :href="`${appMainWeb}/telehealth-consent`" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                        </div>
                                    </div>
                                </form>
                                <div class="w-form-done">
                                    <div>Thank you! Your submission has been received!</div>
                                </div>
                                <div class="w-form-fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="semaco_orderdetails">
                        <div class="plan-select-div">
                            <div class="select-plan-text">Select Your Plan</div>
                            <div class="plan-choices-div">
                                <div class="plans-div">
                                    <div class="sema-plan-div">
                                        <a data-w-id="b31ea479-7c2e-e9ba-e4ea-888c577486fc" href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==3}" @click.prevent="paymentInfo.payment_terms=3">
                                            <div class="plan-type-text">3 Month Plan</div>
                                            <div class="plan-price">${{(getQuaterlyPricing/3).toFixed(2)}} a Month</div>
                                            <div class="plan-price">${{(getQuaterlyPricing).toFixed(2)}} Total 3 Months</div>
                                            <div class="plan-savings-div" style="background: #00A36C;">
                                                <div class="plan-savings-text">Save ${{((getPricingTopOnOffer[0] + getPricingTopOnOffer[1] * 2) - getQuaterlyPricing).toFixed(0)}} Total!</div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="sema-plan-div">
                                        <a data-w-id="b174f680-8f9a-31d7-d2ea-4bac8dfdd6b6" href="#" class="plan-link monthly w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==1}" @click.prevent="paymentInfo.payment_terms=1">
                                            <div class="plan-type-text">Monthly Plan</div>
                                            <div class="plan-price">${{getPricingTopOnOffer[0]}} / 1st month</div>
                                            <div class="plan-price">${{getPricingTopOnOffer[1]}} Thereafter</div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="summary-desk">
                            <div class="monthly-order" style="display:block;">
                                <div class="div-block-960 new">
                                    <div class="div-block-976">
                                        <div class="div-block-974">
                                            <div class="checkout-product-div"><img :src="getImage" loading="lazy" sizes="100vw" :srcset="`${getImage} 500w, ${getImage} 800w, ${getImage} 1080w`" alt=""></div>
                                            <div class="div-block-975" style="background-color: transparent;">
                                                <div class="text-block-161"></div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="product-name-2">{{getcartItems.name}}</div>
                                            <div class="text-block-850" >3 Month Supply</div>
                                            <div class="text-block-850" style="font-size: 12px;cursor: pointer;margin-top:10px"  @click="changeItem(getcartItems.name)">Switch to {{ getcartItems.name === 'Semaglutide' ? 'Tirzepatide' : 'Semaglutide' }}</div>
                                        </div>
                                    </div>
                                    <div class="div-block-1778">
                                        <div class="item-price-text">${{getPricingBasedOnOffer - parseInt(paymentInfo.discount)}}</div>
                                        <div class="text-block-849" v-if="paymentInfo.payment_terms==1">Billed Monthly</div>
                                        <div class="text-block-849" v-else>Billed Quarterly</div>
                                    </div>
                                </div>
                            </div>
                            <div class="plan-inclusions-div">
                                <div class="inclusion-div">
                                    <div class="inclusion-left"><img src="@/assets/images/icon_PM_No_Increase_blk.png" loading="lazy" alt="" class="image-473">
                                        <div class="inclusion-text">All Dosage Increases</div>
                                    </div>
                                    <div class="text-block-1035">FREE</div>
                                </div>
                                <div class="inclusion-div">
                                    <div class="inclusion-left"><img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-473">
                                        <div class="inclusion-text">Telehealth Visit<sup>*</sup></div>
                                    </div>
                                    <div class="text-block-1035">FREE</div>
                                </div>
                                <div class="inclusion-div">
                                    <div class="inclusion-left"><img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-473">
                                        <div class="inclusion-text">Unlimited Clinical Chat<sup>*</sup></div>
                                    </div>
                                    <div class="text-block-1035">FREE</div>
                                </div>
                                
                                <div class="inclusion-div">
                                    <div class="inclusion-left"><img src="@/assets/images/icon_delivery.svg" loading="lazy" alt="" class="image-473">
                                        <div class="inclusion-text">Express Delivery</div>
                                    </div>
                                    <div class="text-block-1035">FREE</div>
                                </div>
                            </div>
                            <div class="quarterly-details-div"  style="padding-top:5px">
                                <p style="font-size: 8px;line-height: normal; padding-bottom:15px">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                                <div class="quart-deet-header-div">
                                    <div class="text-block-1036" v-if="paymentInfo.payment_terms==3">Quarterly Plan:</div>
                                    <div class="text-block-1036" v-else>Monthly Plan:</div>
                                    <div class="div-block-1903" style="background: #00A36C;">
                                        <div class="text-block-1037"  v-if="paymentInfo.payment_terms==3">Best Price </div>
                                        <div class="text-block-1037"  v-else>${{((getPricingTopOnOffer[1] - getPricingTopOnOffer[0]) + paymentInfo.discount).toFixed(0)}} Off Your 1st Month! </div>
                                    </div>
                                </div>
                                <ul role="list" class="list-5">
                                    <li class="list-item-4" v-for="(point,index) in planPoints" :key="`point-plan${index}`">
                                        <div class="text-block-1038">{{point.header}}</div>
                                        <div class="text-block-1039">{{point.sub_header}}</div>
                                    </li>
                                </ul>
                            </div>
                            <div class="couponcodediv _1 coupon new">
                                <div class="form-block-15 w-form">
                                    <form>
                                        <div class="div-block-1897 checkout">
                                            <input class="text-field-55 coupon new w-input" maxlength="256" v-model="couponInput" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required>
                                            <a href="#" class="button-103 new w-button"   @click.prevent="handleCouponSubmit()">Apply</a>
                                        </div>
                                        <div class="w-form-fail" style="display: block;" v-if="couponError">
                                            <div>Invalid Coupon.</div>
                                        </div>
                                    </form>
    
                                </div>
                            </div>
                            <div class="text-block-90">Monthly Access. <span class="text-span-13">Cancel anytime. </span></div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="sema-checkout-mobile" v-else>
                <div class="semaco_orderdetails">
                    <div class="plan-select-div">
                        <div class="select-plan-text">Select Your Plan</div>
                        <div class="plan-choices-div">
                            <div class="plans-div">
                                <div class="sema-plan-div">
                                    <a data-w-id="34cf4a3f-1558-6b5c-91bf-7caa1f520f6f" href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==3}" @click.prevent="changePaymentTerms(3)">
                                        <div class="plan-type-text">3 Month Plan</div>
                                        <div class="plan-price">${{(getQuaterlyPricing/3).toFixed(2)}} a Month</div>
                                        <div class="plan-price">${{(getQuaterlyPricing).toFixed(2)}} Total 3 Months</div>
                                        <div class="plan-savings-div" style="background: #00A36C;">
                                            <div class="plan-savings-text">Save ${{((getPricingTopOnOffer[0] + getPricingTopOnOffer[1] * 2) - getQuaterlyPricing).toFixed(0)}} Total!</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="sema-plan-div">
                                    <a data-w-id="34cf4a3f-1558-6b5c-91bf-7caa1f520f78" href="#" class="plan-link monthly w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==1}" @click.prevent="changePaymentTerms(1)">
                                        <div class="plan-type-text">Monthly plan</div>
                                        <div class="plan-price">${{getPricingTopOnOffer[0]}} / 1st month</div>
                                        <div class="plan-price">${{getPricingTopOnOffer[1]}} Thereafter</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="summary-desk">
                        <div class="quartely-order">
                            <div class="div-block-960 new">
                                <div class="div-block-976">
                                    <div class="div-block-974">
                                        <div class="checkout-product-div"><img :src="getImage" loading="lazy" sizes="100vw" :srcset="`${getImage} 500w, ${getImage} 800w, ${getImage} 1080w`" alt=""></div>
                                        <div class="div-block-975" style="background-color: transparent;">
                                            <div class="text-block-161" style="color: #fff;"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="product-name-2">{{getcartItems.name}}</div>
                                        <div class="text-block-850" >3 Month Supply</div>
                                        <div class="text-block-850" style="font-size: 12px;cursor: pointer;margin-top:10px"  @click="changeItem(getcartItems.name)">Switch to {{ getcartItems.name === 'Semaglutide' ? 'Tirzepatide' : 'Semaglutide' }}</div>
                                    </div>
                                </div>
                                <div class="div-block-1778">
                                    <div class="item-price-text">${{getPricingBasedOnOffer - parseInt(paymentInfo.discount)}}</div>
                                    <div class="text-block-849" v-if="paymentInfo.payment_terms==1">Billed Monthly</div>
                                    <div class="text-block-849" v-else>Billed Quarterly</div>
                                </div>
                            </div>
                        </div>
                        <div class="monthly-order">
                            <div class="div-block-960 new">
                                <div class="div-block-976">
                                    <div class="div-block-974">
                                        <div class="checkout-product-div"><img :src="getImage" loading="lazy" sizes="100vw" :srcset="`${getImage} 500w, ${getImage} 800w, ${getImage} 1080w`" alt=""></div>
                                        <div class="div-block-975" style="background-color: transparent;">
                                            <div class="text-block-161" style="color: #fff;"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="product-name-2">{{getcartItems.name}}<br></div>
                                        <div class="text-block-850">3 Month Supply</div>
                                    </div>
                                </div>
    
                                <div class="div-block-1778">
                                    <div class="item-price-text">${{getPricingBasedOnOffer}}</div>
                                    <div class="text-block-849" v-if="paymentInfo.payment_terms==1">Billed Monthly</div>
                                    <div class="text-block-849" v-else>Billed Quarterly</div>
                                </div>
                            </div>
                        </div>
                        <div class="plan-inclusions-div">
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_PM_No_Increase_blk.png" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">All Dosage Increases</div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">Telehealth Visit<sup>*</sup></div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">Unlimited Clinical Chat<sup>*</sup></div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                            
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_delivery.svg" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">Express Delivery</div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                        </div>
                        <div class="quarterly-details-div" style="padding-top:5px">
                            <p style="font-size: 8px;line-height: normal; padding-bottom:15px">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                            <div class="quart-deet-header-div">
                                <div class="text-block-1036"  v-if="paymentInfo.payment_terms==3">Quarterly Plan:</div>
                                <div class="text-block-1036" v-else>Monthly Plan:</div>
                                <div class="div-block-1903" style="background: #00A36C;">
                                    <div class="text-block-1037"   v-if="paymentInfo.payment_terms==3">Best Price </div>
                                    <div class="text-block-1037"   v-else>${{(getPricingTopOnOffer[1] - getPricingTopOnOffer[0]).toFixed(0)}} Off Your 1st Month! </div>
                                </div>
                            </div>
                            <ul role="list" class="list-5">
                                <li class="list-item-4" v-for="(point,index) in planPoints" :key="`point-plan${index}`">
                                    <div class="text-block-1038">{{point.header}}</div>
                                    <div class="text-block-1039">{{point.sub_header}}</div>
                                </li>
                            </ul>
                        </div>
                        <div class="couponcodediv _1 coupon new">
                            <div class="form-block-15 w-form">
                                <form id="email-form-4" name="email-form-4" data-name="Email Form 4" method="get" data-wf-page-id="674d4a5a7395cd3bb3e7f579" data-wf-element-id="34cf4a3f-1558-6b5c-91bf-7caa1f520ff6">
                                    <div class="div-block-1897 checkout">
                                        <input class="text-field-55 coupon new w-input" maxlength="256" name="field-3" data-name="Field 3" v-model="couponInput" placeholder="Coupon Code" type="text" id="field-3" required>
                                        <a href="#" @click.prevent="handleCouponSubmit()"   class="button-103 new w-button">Apply</a>
                                    </div>
                                    <div class="w-form-fail" style="display: block;" v-if="couponError">
                                        <div>Invalid Coupon.</div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="text-block-90">Monthly Access. <span class="text-span-13">Cancel anytime. </span></div>
                    </div>
                </div>
                <div class="express-main-div" v-if="isGooglePaySupported">
                    <div class="express-box">
                        <div class="text-block-334">Express Checkout</div>
                        <div class="express-element-container">
                            <!--<div id="applepaybutton" style="width: 70%;"></div>-->
                            <div class="express-left-button">
                                <div id="googlepaybutton"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="div-block-1284">
                    <div class="text-block-335" v-if="isGooglePaySupported">OR CONTINUE BELOW TO PAY WITH CREDIT CARD</div>
                    <div class="w-form">
                        <form class="step-2-left-payment-form new-checkout new-mobile _2" @submit.prevent="getStripeToken()">
    
                            <div class="div-block-853 new">
                                <div class="text-block-80"><strong>Credit Card</strong></div><img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103790_visa.png" class="image-471"><img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103780_mastercard.png" class="image-471"><img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103794_AmEx.png" class="image-471"><img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd3610377e_discover.png" class="image-471">
                            </div>
                            <div><label for="Card-number" class="field-label-4">Card Number</label>
                                <div id="card-element" class="ns-card-element" ref="myElement"></div>
                            </div>
                            <label for="Address" class="field-label-4 new">Shipping Address</label>
                            <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                            <label for="email" class="field-label-4">
                            <input type="checkbox" @change="differentShipping = !differentShipping"> Different Billing Address?</label>
                            <div v-if="differentShipping">
                                <label for="email" class="field-label-4">Billing Address</label>
                                <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressDataBilling" />
                            </div>
                            <button class="submit-button-3 new w-button" :disabled="submitted" >
                                <span v-if="submitted"><img src="@/assets/images/submitted.svg"></span>
                                <span v-else>Buy Now and Save</span>
                            </button>
    
                            <div class="div-block-1154">
                                <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                                <div class="text-block-252">
                                    By clicking "Buy Now and Save" or checking out with Apple or Google Pay you agree to enroll in a 3-month program billed <span v-if="paymentInfo.payment_terms==1">monthly</span><span v-else>quarterly</span>, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the <a :href="`${appMainWeb}/returns`" target="_blank">Refund Policy</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms and Conditions</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms of Use</a>, <a :href="`${appMainWeb}/privacy`" target="_blank">Privacy Policy</a>, <a :href="`${appMainWeb}/hipaa`" target="_blank">HIPAA Notice</a>, and <a :href="`${appMainWeb}/telehealth-consent`" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                </div>
                            </div>
                        </form>
                        <div class="w-form-fail" style="display:block" v-if="paymentError">
                            <div>{{errorMessage}} </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:280px;"></div>
    </div>
    </template>
    
        
        
    <script>
    import {
        BasisTheory
    } from "@basis-theory/basis-theory-js";
    const bt = await new BasisTheory().init(process.env.VUE_APP_BASIS, {
        elements: true
    });
    import detectMobile from '@/utils/MobileDetection.js'
    import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue'
    import blurryLoader from '../common/blurryLoader.vue'
    import {
        mapActions,
        mapGetters
    } from 'vuex';
    
    export default {
        name: 'CheckoutComponent',
        components: {
            GooglePlacesAutocomplete,
            blurryLoader,
        },
        props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
        data() {
            return {
                appName: process.env.VUE_APP_COMPANY,
                appMainWeb: process.env.VUE_APP_HOMEPAGE,
                payment_open: 0,
                paymentError: false,
                initilizingCart: true,
                cartError: false,
                isApplePaySupported: false,
                isGooglePaySupported: false,
                differentShipping: false,
                couponValid: true,
                couponError: false,
                submitted: false,
                trustUrl:'',
                couponInput: '',
                message: '',
                offer: '',
                customerInfo: {
                    id: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    zip: ''
                },
                billingAddress: {
                    id: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    zip: ''
                },
                paymentInfo: {
                    payment_terms: 3,
                    user_id: '',
                    cardToken: '',
                    amount: 499,
                    discount: 0,
                    medication: '',
                    couponCode: '',
                    drug_mode: '',
                    couponId: null,
                    paymentMethod: null,
                    cartItems: [],
                    cardDetails: [],
                    planId: '',
                },
            }
        },
    
        async mounted() {
            await this.checkAuthAndInitialize();
    
        },
        created() { 
            try{
                  window.fbq('track', 'InitiateCheckout');
                  console.log("facebook pixel fired initiatecheckout");
               }catch(error){
                  console.log("Error in facebook pixel fired ", error);
               }
        },
        watch: {
            isMobile: {
            immediate: true,
            handler(newVal) {
                console.log('Mobile view:', newVal);
            }
        },
            'paymentInfo.payment_terms'() {
                this.couponInput="";
                this.paymentInfo.couponId= null;
                this.couponApplied= false;
                this.paymentInfo.discount=0;
            }
        },
        methods: {
            ...mapActions([
                'setCartVisibility',
                'clearCart'
            ]),
            async changeItem(currentName) {
                try {
                    // Reset states
                    this.couponInput = "";
                    this.paymentInfo.couponId = null;
                    this.couponApplied = false;
                    this.paymentInfo.discount = 0;
                    this.paymentError = false;
                    this.submitted = false;
    
                    // Create new item
                    const newItem = {
                        name: currentName === 'Semaglutide' ? 'Tirzepatide' : 'Semaglutide',
                        quantity: 1,
                        image: currentName === 'Semaglutide' 
                            ? 'https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/tirzepatide/1.webp' 
                            : 'https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/semaglutide/1.webp',
                            category: "Weight",
                            id: currentName === 'Semaglutide' ? "675ac4cb6bf102c19ec3afec" : "675ac4cb6bf102c19ec3afe9",
                            main_type: 1,
                            price:currentName === 'Semaglutide' ? 249.97 : 149.97,
                            retail_price: currentName === 'Semaglutide' ? 249.97 : 149.97,
                            stripe_id: currentName === 'Semaglutide' ? 'tirz_plan_1' : 'sema_plan_278928',
                            kku: currentName === 'Semaglutide' ? '23_1' : "24",
                            subheader:"Compound Medication"
                    };
    
                    // Update cart
                    await this.$store.dispatch('clearCart');
                    await this.$store.dispatch('addToCart', newItem);
                    this.setCartVisibility(false);
                    window.location.reload();
                    // Reset payment integrations
                    if (window.CollectJS) {
                        this.initializeCollectJS();
                    }
                    if (this.cardElement) {
                        this.cardElement.clear();
                    }
    
                    // Track event
                    try {
                        window.fbq('track', 'InitiateCheckout');
                        console.log("facebook pixel fired initiatecheckout");
                    } catch(error) {
                        console.log("Error in facebook pixel fired ", error);
                    }
    
                } catch (error) {
                    console.error('Error switching medication:', error);
                    this.paymentError = true;
                    this.errorMessage = "Error switching medication. Please try again.";
                }
            },
            showChatWindow(){
                this.$emit("showChatWindow");
            },
            async handleCouponSubmit() {
                this.errorMessage = null;
                if (!this.couponInput) {
                    this.errorMessage = 'Please enter a coupon code';
                    return;
                }
                this.paymentInfo.couponCode = this.couponInput;
                await this.validateCoupon();
            },
    
            // UPDATED: Modified to send cart items with coupon validation
            async validateCoupon() {
                if (this.couponApplied) return;
                this.couponError = false;
                try {
                    const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                        coupon: this.paymentInfo.couponCode,
                        payment_terms: this.paymentInfo.payment_terms // Send cart items for validation
                    });
    
                    if (response.data.status === 'success') {
                        this.couponValid = true;
                        this.couponApplied = true;
                        this.paymentInfo.couponId = response.data.coupon_id;
                        this.paymentInfo.discount = response.data.c_val;
                    } else {
                        this.couponValid = false;
                        this.couponError= true;
                    }
                } catch (error) {
                    this.couponValid = false;
                    this.couponError= true;
                }
            },
            checkAuthAndInitialize() {
                if (!this.isLoggedin) {
                    this.$axios.get(`${this.baseUrl}/api/get-cart/${this.$route.params.cart_id}`, {
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        }).then(response => {
                            if (response.data.status === 'success') {
                                let cartItem = response.data.cartItem;
                                try {
                                    let keyToDelete = "sema_offer";
                                    if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                        this.$store.dispatch('addSemaOffer', cartItem[keyToDelete]);
                                        delete cartItem[keyToDelete];
                                    }
                                    keyToDelete = "tir_offer";
                                    if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                        this.$store.dispatch('addTirOffer', cartItem[keyToDelete]);
                                        delete cartItem[keyToDelete];
                                    }
                                } catch (error) {
                                    console.log(error.message)
                                }
    
                                this.$store.dispatch("doLogin", response.data.userData);
                                this.$store.dispatch('addToCart', cartItem);
                                this.setCartVisibility(false);
                                window.location.reload();
    
                            } else {
                                this.initilizingCart = false;
                                this.message = response.data.message;
                                this.cartError = true;
                                console.error("Unexpected response:", response.data);
                            }
                        })
                        .catch(error => {
                            console.error("Error saving cart:", error);
                            this.initilizingCart = false;
                            this.message = `${error.message}. Please check the checkout link is correct.`
                            this.cartError = true;
                        });
                } else {
                    this.initilizingCart = false;
                    this.createCardElement();
                    this.addScriptOnHead();
                }
            },
            openPaymentMethod(val) {
                if (val == this.payment_open) {
                    this.payment_open = 0;
                } else {
                    this.payment_open = val;
                }
            },
            async checkPaymentMethodSupport() {
                // Check if Google Pay is available in the environment
                if (window.CollectJS) {
                    try {
                        // First initialize CollectJS with minimal configuration
                        window.CollectJS.configure({
                            'theme': 'bootstrap',
                            'fields': {
                                'googlePay': {
                                    'buttonColor': 'default',
                                    'buttonType': 'plain'
                                }
                            },
                            'price': this.getPricingBasedOnOffer.toString(),
                            'currency': 'USD',
                            'country': 'US'
                        });
    
                        // Check if Google Pay is available
                        if (window.google && window.google.payments && window.google.payments.api) {
                            const client = new window.google.payments.api.PaymentsClient({
                                environment: 'TEST'
                            });
    
                            const isReadyToPay = await client.isReadyToPay({
                                apiVersion: 2,
                                apiVersionMinor: 0,
                                allowedPaymentMethods: [{
                                    type: 'CARD',
                                    parameters: {
                                        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                        allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'],
                                    }
                                }]
                            });
    
                            this.isGooglePaySupported = isReadyToPay.result;
                        } else {
                            this.isGooglePaySupported = false;
                        }
                    } catch (error) {
                        this.isGooglePaySupported = false;
                    }
                }
            },
            changePaymentTerms(value) {
                this.paymentInfo.payment_terms = value;
                this.initializeCollectJS();
            },
            initializeCollectJS() {
                let vm = this;
                let config = {
                    'theme': 'bootstrap',
                    'fields': {},
                    'price': this.getPricingBasedOnOffer.toString(),
                    'currency': 'USD',
                    'country': 'US',
                    'callback': function (response) {
                        console.log(JSON.stringify(response))
                        vm.extractPaymentData(response);
                    }
                };
    
                if (this.isGooglePaySupported) {
                    config.fields.googlePay = {
                        'buttonType': 'plain',
                        'buttonColor': 'white',
                        'buttonLocale': 'en',
                        'emailRequired': true,
                        'billingAddressRequired': true,
                        'shippingAddressRequired': true,
                        'shippingAddressParameters': {
                            'phoneNumberRequired': true,
                            'allowedCountryCodes': ['US']
                        },
                    };
                }
                window.CollectJS.configure(config);
            },
    
            async addScriptOnHead() {
                // Load the Google Pay API
                const googlePayScript = document.createElement('script');
                googlePayScript.src = 'https://pay.google.com/gp/p/js/pay.js';
                document.head.appendChild(googlePayScript);
    
                await new Promise(resolve => {
                    googlePayScript.onload = resolve;
                });
    
                await this.checkPaymentMethodSupport();
                this.initializeCollectJS();
            },
            createCardElement() {
                this.cardElement = bt.createElement('card');
                this.cardElement.mount('#card-element');
            },
            extractPaymentData(response) {
                try {
                    this.submitted = true;
                    this.paymentInfo.paymentMethod = response.tokenType;
                    this.paymentInfo.cardToken = response.token || null;
                    this.paymentInfo.planId = this.getOfferName;
                    this.paymentInfo.cardDetails = {
                        method: response.tokenType
                    }
                    const shippingInfo = (response.wallet?.shippingInfo || response.shippingInfo) || {};
                    this.customerInfo.addressLine1 = shippingInfo.address1 || shippingInfo.street || '';
                    this.customerInfo.city = shippingInfo.city || '';
                    this.customerInfo.state = shippingInfo.state || '';
                    this.customerInfo.zip = shippingInfo.postalCode || '';
                    this.updateAddress();
                    this.processPayment();
                } catch (error) {
                    console.error('Error extracting payment data:', error);
                    this.submitted = false;
                    return null;
                }
            },
            getAddressData(address) {
                this.customerInfo.addressLine1 = address.street;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
                this.updateAddress();
            },
            getAddressDataBilling(address){
                console.log("setting up address")
                this.billingAddress.addressLine1 = address.street;
                this.billingAddress.addressLine2 = address.address_line2;
                this.billingAddress.city = address.city;
                this.billingAddress.state = address.state;
                this.billingAddress.zip = address.zip;
                console.log(this.billingAddress)
            },
            async updateAddress() {
                try {
                    this.customerInfo.id = this.user.id;
                    await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
                } catch (error) {
                    console.error('Error updating address:', error);
                    throw new Error('Failed to update address');
                }
            },
            validateAddress(address) {
            return address.addressLine1 && 
                    address.city && 
                    address.state && 
                    address.zip;
            },
            getStripeToken() {
                this.submitted = true;
                this.paymentError = false;
                if (!this.validateAddress(this.customerInfo)) {
                    this.paymentError = true;
                    this.errorMessage = "Please enter a complete shipping address.";
                    this.submitted = false;
                    return false;
                }
                if (this.differentShipping && !this.validateAddress(this.billingAddress)) {
                    this.paymentError = true;
                    this.errorMessage = "Please enter a complete billing address.";
                    this.submitted = false;
                    return false;
                }
                this.errorReason = false;
                bt.tokens
                    .create({
                        type: "card",
                        data: this.cardElement,
                    })
                    .then((token) => {
                        this.paymentInfo.cardToken = token.id;
                        this.paymentInfo.cardDetails = token.data;
                        this.paymentInfo.paymentMethod = 'card';
                        this.processPayment();
                    })
                    .catch((error) => {
                        console.log(error);
                        this.paymentError = true;
                        this.errorMessage = "Invalid card details";
                        this.submitted = false;
                    });
            },
            async sendRequest(paymentData) {
                let response = await this.$axios.post(`${this.baseUrl}/api/checkout-new`, paymentData)
                return response;
            },
            async processPayment() {
                try{
                    this.trustUrl = this.$refs.trustedFormUrl.value;
                }catch(error){
                    console.log("no trust form found")
                }
                try {
                    this.submitted = true;
                    this.paymentError = false;
                    this.paymentInfo.user_id = this.user.id;
                    this.paymentInfo.id = this.user.id;
                    this.paymentInfo.cartItems = this.cartItems;
                    this.paymentInfo.planId = this.getOfferName;
                    let paymentData = {
                        ...this.paymentInfo,
                        amount: this.amountInCents,
                        cartTotal: this.cartTotal,
                        cartTotalNoDiscount: this.cartTotalNoDiscount,
                        offer: this.offer,
                        billingAddress: this.customerInfo,
                        shippingAddress: this.customerInfo,
                    };
    
                    if(this.differentShipping){
                        paymentData = {
                            ...this.paymentInfo,
                            billingAddress: this.billingAddress,
                            shippingAddress: this.customerInfo,
                            amount: this.amountInCents,
                            cartTotal: this.cartTotal,
                            cartTotalNoDiscount: this.cartTotalNoDiscount,
                            offer: this.offer,
                        };
                    }
                    
                    const response = await this.sendRequest(paymentData);
    
                    if (response.data.status === 'success') {
                        await this.$store.dispatch('setPrescriptionPreauths', response.data.prescriptionPreauths);
                        await this.saveTrustFrom(this.trustUrl);
                        await this.updateAddress();
                        await this.clearCart();
                        this.pushToRoute();
                        this.submitted = false;
                    } else {
                        this.paymentError = true;
                        this.errorMessage = "Uh oh! It looks like your card was declined. No worries—your bank might have sent you a text to approve the charge. Just reply to their message to approve it and try again, or feel free to use a different card.";
                        this.submitted = false;
                    }
                } catch (error) {
                    this.paymentError = true;
                    this.errorMessage = "Uh oh! It looks like your card was declined. No worries—your bank might have sent you a text to approve the charge. Just reply to their message to approve it and try again, or feel free to use a different card.";
                    if(error.response.data.message==='An active order exists on your account. Please login to your account to view or modify it.'){
                        this.errorMessage="An active order exists on your account. Please login to your account to view or modify it."
                    }
                    this.submitted = false;
                }
            },
            saveTrustFrom(url){
                try{
                    this.$axios.post(`${this.baseUrl}/api/trust-form`, { "user_id": this.user.id, "url": url });
                }catch(error){
                    console.log("error saving url trust");
                }
            },
            pushToRoute() {
                this.$router.push({
                    name: 'prescriptionThanks',
                });
            },
        },
        computed: {
            ...mapGetters([
                'user',
                'cartItems',
                'cartTotal',
                'cartDiscount',
                'cartTotalNoDiscount'
            ]),
            getOfferName() {
                let offer = this.$store.getters.offerTir;
    
                if (this.getcartItems.name === 'Semaglutide') {
                    offer = this.$store.getters.offerSema;
                }
                return offer;
            },
            getPricingTopOnOffer() {
                if (this.getcartItems.name === 'Semaglutide') {
                    return [149.97, 249.97];
                } else{
                    return [249.97, 349.97];
                }
            },
            getQuaterlyPricing() {
                return this.getcartItems.name === 'Semaglutide' ? 449.97 : 749.97
            },
    
            getPricingBasedOnOffer() {
                localStorage.setItem("planName", JSON.stringify(this.getcartItems.name));
                if (this.paymentInfo.payment_terms == 3) {
                    return this.getcartItems.name === 'Semaglutide' ? 449.97 : 749.97
                } else if (this.getcartItems.name === 'Semaglutide') {
                    return 149.97;
                } else if (this.getcartItems.name === 'Tirzepatide') {
                    return  249.97;
                }
    
                return this.getcartItems.retail_price;
            },
            getImage() {
                return this.getcartItems.image;
            },
            getcartItems() {
                return this.cartItems[0];
            },
            isMobile() {
                return detectMobile();
            },
            isLoggedin() {
                return this.$store.getters.isAuthenticated;
            },
            planPoints() {
                if (this.paymentInfo.payment_terms === 3) {
                    return [
                        {
                            "header": `$${((((this.getPricingTopOnOffer[1]*2) + this.getPricingTopOnOffer[0] + this.paymentInfo.discount) - this.getQuaterlyPricing)/3).toFixed(0) } a month savings!`,
                            "sub_header": `You will save ${((((this.getPricingTopOnOffer[1]*2) + this.getPricingTopOnOffer[0] + this.paymentInfo.discount) - this.getQuaterlyPricing)/3).toFixed(0) } a month paying for 3 months up front (${((((this.getPricingTopOnOffer[1]*2) + this.getPricingTopOnOffer[0]) - this.getQuaterlyPricing)).toFixed(0) } total) vs. our monthly installment plan.`
                        },
                        {
                            "header": `Save up to ${(100-((this.getQuaterlyPricing - this.paymentInfo.discount)/((this.getPricingTopOnOffer[1]*2) + this.getPricingTopOnOffer[0])*100)).toFixed(0) }% `,
                            "sub_header": "You will save big by paying for our 3 month program up front."
                        }
                    ];
                }
                return [{
                        "header": `$${this.getPricingTopOnOffer[0] - this.paymentInfo.discount} for the First Month`,
                        "sub_header": "This amount applies only to the first month, providing an upfront discount to new customers."
                    },
                    {
                        "header": `$${this.getPricingTopOnOffer[1]} per month thereafter`,
                        "sub_header": `After the first month, the customer will be charged the regular price of ${this.getPricingTopOnOffer[1]} monthly.`
                    },
                    {
                        "header": "3 Month Supply Program",
                        "sub_header": "You’ll receive a 3-month supply of medication, billed monthly. If you cancel before completing the full term, an early termination fee of $279.97 will apply."
                    }
                ];
            },
            canSubmit() {
                return this.cartItems.length > 0 &&
                    this.termsAccepted &&
                    this.ageVerified &&
                    this.customerInfo.addressLine1 &&
                    this.customerInfo.city &&
                    this.customerInfo.state &&
                    this.customerInfo.zip;
            },
            finalTotal() {
                if (this.couponApplied) {
                    return this.cartTotalNoDiscount - this.paymentInfo.discount
                }
                return this.cartTotal;
            },
            amountInCents() {
                return Math.round(this.getPricingBasedOnOffer * 100);
            },
            getDiscount() {
                if (this.couponApplied) {
                    return this.paymentInfo.discount
                }
                return this.cartDiscount;
            },
            cartFirstItem() {
                try {
                    return [this.cartItems[0]];
                } catch (error) {
                    return [];
                }
            },
            cartItemsMinusFirst() {
                let temp = this.cartItems;
                return temp.slice(1);
            }
        },
    }
    </script>
        
        
    <style>
   
   
    
    .express-element-container {
        display: flex;
        justify-content: center;
        /* Center the buttons horizontally */
        align-items: center;
        /* Align buttons vertically */
        gap: 10px;
        /* Space between buttons */
        width: 100%;
    }
    
    .express-right-button,
    .express-left-button {
        display: inline-block;
        width: auto;
        /* Default width for both buttons */
    }
    
    .express-element-container.single-button .express-right-button,
    .express-element-container.single-button .express-left-button {
        width: 75%;
        /* 75% width for a single button on larger screens */
    }
    
    @media (max-width: 768px) {
    
        /* Target mobile devices */
        .express-element-container {
            flex-direction: column;
            /* Stack buttons vertically */
            gap: 15px;
        }
    
        .express-right-button,
        .express-left-button {
            width: 100%;
            /* 100% width for all buttons on mobile */
        }
    
        .express-element-container.single-button .express-right-button,
        .express-element-container.single-button .express-left-button {
            width: 100%;
            /* Single button takes full width on mobile */
        }
    }
    
    .checkout-product-div {
        background-color: #c9e8ff;
        background-image: none;
    }
    
    .google-pay-button-container {
        height: 48px !important;
    }
    
    .google-pay-button {
        height: 48px !important;
    }
    
    .div-block-1154-centered {
        flex-flow: column;
        justify-content: center;
        align-items: center;
        display: flex;
        padding-left: 10px;
    }
    
    .image-31-desk {
        margin-top: 15px;
        width: auto;
        height: 22px;
        margin-bottom: 0;
    }
  
    </style>
    